import { ArrowDown, ArrowRight, FlaskConical, HeartHandshake, ShieldCheck, WifiOff } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useDemoConfig } from '../lib/demoConfig';

export const WelcomeHero = () => {
  const demo = useDemoConfig();
  return (
  <>
    <section className="wl-hero" aria-labelledby="welcome-headline" data-testid="welcome-hero">
      <picture className="wl-hero-picture">
        <source media="(max-width: 767px)" srcSet="/images/welcome/hero-mobile.webp" />
        <img src="/images/welcome/hero.webp" width="1264" height="848" fetchPriority="high"
          alt="Illustrative Ghanaian pharmacist discussing medication with a patient in a community pharmacy"
          data-testid="welcome-hero-image" />
      </picture>
      <div className="wl-hero-scrim" aria-hidden="true" />
      <div className="wl-wrap wl-hero-inner">
        <div className="wl-hero-copy">
          <p className="wl-eyebrow wl-hero-eyebrow"><span /> DUTILYNE · PHARMACY POS</p>
          <h1 id="welcome-headline" data-testid="welcome-headline">More care.<br /><span>Less complexity.</span></h1>
          <p className="wl-hero-description" data-testid="welcome-positioning">Lightweight, offline-first pharmacy software.<br className="wl-desktop-break" /> Bringing everyday operations and pharmacist-led,<br className="wl-desktop-break" /> patient-centred care together.</p>
          <div className="wl-hero-actions">
            {demo.enabled && (
              <Link to="/try-demo" className="wl-button wl-button-primary wl-button-demo" data-testid="welcome-hero-open-demo">
                <FlaskConical size={17} /> Open the demo pharmacy
              </Link>
            )}
            <a href="#demo" className={`wl-button ${demo.enabled ? 'wl-button-glass' : 'wl-button-primary'}`} data-testid="welcome-hero-cta">Request a demo <ArrowRight size={17} /></a>
            <a href="#clinical" className="wl-button wl-button-glass" data-testid="welcome-explore-platform">Explore the platform <ArrowDown size={16} /></a>
          </div>
          {demo.enabled && (
            <p className="wl-hero-demo-note" data-testid="welcome-hero-demo-note">No sign-up, no password — sample data only.</p>
          )}
          <p className="wl-hero-tagline" data-testid="welcome-tagline">Closer to your patients, Connected to your Pharmacy.</p>
          <p className="wl-hero-context" data-testid="welcome-hero-context">For community pharmacies. Rooted in Africa.</p>
        </div>
      </div>
      <span className="wl-hero-caption" data-testid="welcome-hero-caption">A human connection. An illustrative care scene.</span>
    </section>
    <div className="wl-principles">
      <div className="wl-wrap">
        <span><HeartHandshake size={20} /> Pharmacist-led. Patient-centred.</span>
        <span><WifiOff size={20} /> Offline-first at the counter.</span>
        <span><ShieldCheck size={20} /> Shared with permission.</span>
        <a href="#clinical" data-testid="welcome-discover-link">Meet your connected pharmacy <ArrowDown size={16} /></a>
      </div>
    </div>
  </>
  );
};